export const BREAKPOINTS = {
  mobileMax: 820,
  tabletMin: 821,
  narrowDesktopMin: 767,
  narrowDesktopMax: 1025,
  desktopMin: 1024
};

export const DIMENSIONS = {
  sidebarWidth: 225
};

export const MOBILE_MAX_WIDTH = 480;

export const media = {
  max: (px) => `@media (max-width: ${px}px)`,
  min: (px) => `@media (min-width: ${px}px)`,
  between: (minPx, maxPx) => `@media (min-width: ${minPx}px) and (max-width: ${maxPx}px)`
};

export const getBackgroundColor = ({
  backGray,
  backGreen,
  backLightGray,
  backWhite,
  theme
}) => {
  if (backLightGray) return theme.palette.background.lightGray;
  if (backGray) return theme.palette.background.gray;
  if (backGreen) return theme.palette.primary.green;
  if (backWhite) return theme.custom.white;
  return "transparent";
};

